export class Constant {
  public static min_length_email = 4;
  public static max_length_description = 160;
  // Voice Call
  public static voice_call_available = 'AVAILABLE';
  public static voice_call_invisible = 'INVISIBLE';

  //Key localStorage
  public static key_local_token = "token";
  public static key_local_version = "version";
  public static key_local_language = "language";
  public static key_local_status = "status";

  //Error code
  public static error_force_logout = 401;
  public static error_not_connect_server = 0;
  public static error_server_error = 500;
  public static error_server_maintenance = 503;
  public static error_code = 400;

  //Success code
  public static success_code = 200;
  public static ERROR_CODE_RENEW_PASSWORD = 40027;

   //Default variable
   public static default_language = "vi_VN";
   //API key upload
   public static clientApiKey = 'clientApiKey';
   public static clientApiKey_value = 'FMARKET-ANGULAR';
   public static clientApiKey_value_report = 'FMARKET-ANGULAR-KEY2';
   public static requestId = 'requestId';
   public static fileType = 'fileType';
   public static photoType = 'photoType';
   public static base64File = 'base64File';
   public static fileTypeNormal = 'FILE';
   public static fileTypePhoto = 'PHOTO';
   public static applyOriginalFileName = 'applyOriginalFileName';

  public static const_timeout_dowload_file = 2 * 60 * 1000;
  //API
  public static API_UPLOAD = '/file/fileUploadAdmin?clientApiKey=FMARKET-ANGULAR-KEY2';
  public static API_UPLOAD_BLOG = '/blog/file/upload';
   //Product code
   public static CODE_ORDER_FUND = 'FUND';
   public static CODE_NEW_FUND = 'NEW_FUND';
   public static CODE_TRADING_FUND = 'TRADING_FUND';
   public static CODE_ORDER_CD = 'CD';
   public static CODE_FIXED_INTEREST_ON_FIXED_CD= 'FIXED_INTEREST_ON_FIXED_CD';
   public static CODE_FLEXIBLE_INTEREST_ON_FIXED_CD = 'FLEXIBLE_INTEREST_ON_FIXED_CD';
   public static CODE_FLEXIBLE_CD = 'FLEXIBLE_CD';
   public static CODE_ORDER_BOND = 'BOND';
   public static CODE_BOND = 'PRODUCT_BOND';
   public static CODE_FUND = 'PRODUCT_FUND';
   public static CODE_CD = 'PRODUCT_CD';
   public static CODE_MATURITY_BOND = 'FLEXIBLE_YIELD_ON_FIXED_BOND';
   public static CODE_FIXED_BOND = 'FIXED_BOND';
   public static CODE_FLEXIBLE_BOND = 'FLEXIBLE_BOND';
   public static PRODUCT_CODE = 'PRODUCT_FUND_NEW';
   public static PRODUCT_ACTIVE = 'PRODUCT_ACTIVE';
  // Regex
  public static REGEX_EMAIL = '/^\w+@([0-9a-zA-Z]+\.?)+$/';
  public static const_default_format_date = 'dd/MM/yyyy';
  public static const_default_format_date_option = 'dd/mm/yyyy';
  public static ITEMS_PER_PAGE = 10;
  public static MAX_SIZE_IMAGE = 5*1024*1024; // size 5MB
  public static MAX_ITEMS_UPLOAD = 10;
  public static TYPE_IMAGES_LIST = [
    {
      key: 'icon',
      value: 'Icon'
    },
    {
      key: 'thumnail',
      value: 'Thumnail'
    }
  ];
  public static TYPE_IMAGES = {
    icon: 'Icon',
    thumnail: 'Thumnail'
  }
  // Regex
  public static CONTROL_TYPES = [
    { id: 1, code: "dropdown", name: "Drop-down list" },
    { id: 2, code: "radio", name: "Radio button list" },
    { id: 3, code: "checkbox", name: "Checkboxes" },
    { id: 4, code: "text", name: "Textbox" },
    { id: 5, code: "textare", name: "Multiline textbox" },
    { id: 6, code: "slider", name: "Slider" },
    { id: 7, code: "number", name: "Number" },
  ];
  public static CONTROL_TYPES_OBJECT = {
    "dropdown": "dropdown",
    "radio": "radio",
    "checkbox": "checkbox",
    "text": "text",
    "textare": "textare",
    "slider": "slider",
    "number": "number",
  };
  public static ORDERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

  public static extension_img = "jpg|JPG|jpeg|JPEG|tiff|TIFF|png|PNG|bmp|BMP|bgp|BGP|PPM|ppm|PGM|pgm|pbm|PBM|ico|ICO|PGF|pgf|IMG|img";
  public static extension_file_doc = "pdf|PDF|xls|XLS|xlsx|XLSX|doc|DOC|docx|DOCX|zip|ZIP|rar|RAR";
  public static checkMobile() {
    let check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor);
    return window.screen.width < 768 ? check : false;
  }

  public static checkAndroid() {
    let userAgent = navigator.userAgent || navigator.vendor;
    return /android/i.test(userAgent);
  }

  public static checkIOS() {
    let userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "iOS";
    }
  }

  public static getMatchingEventName(): string[] {
    return [
      'dealingUpdated',
      'dealingRequested',
      'dealingAccepted',
      'dealingDeleted',
      'dealingApproved',
      'dealingRejected',
      'dealingReserved',
    ];
  }
}
